import type { ModelResultType } from "../../../shared-logic/features/filters/utils/constants/resultConstants";
import {
    type TradeInAemModelSelectActions,
    TRADE_IN_AEM_MODEL_SELECT_SELECT_CAR_TYPE,
    TRADE_IN_AEM_MODEL_SELECT_SET_ENABLED,
    TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_ID,
    TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_LIST,
} from "../actions/TradeInAemModelSelectActions";
import type { TradeInAemModelSelectType } from "../../utils/constants";

export type TradeInAemModelSelectReducerType = {
    initialized: boolean;
    enabled: boolean; // True when the model-select step is enabled
    selectedCarType: TradeInAemModelSelectType | null;
    selectedModelId: string;
    modelList: ModelResultType[]; // Reuses filter datasets as the dataset is basically the same.
};

export const initialStateTradeInAemModelSelect: TradeInAemModelSelectReducerType = {
    initialized: false,
    enabled: false,
    selectedCarType: null,
    selectedModelId: "",
    modelList: [],
};

const TradeInAemModelSelectReducer = (
    state: TradeInAemModelSelectReducerType = initialStateTradeInAemModelSelect,
    action: TradeInAemModelSelectActions,
): TradeInAemModelSelectReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_MODEL_SELECT_SET_ENABLED:
            return { ...state, enabled: action.enabled };

        case TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_LIST:
            return { ...state, modelList: action.modelList, initialized: true };

        case TRADE_IN_AEM_MODEL_SELECT_SELECT_CAR_TYPE:
            return { ...state, selectedCarType: action.carType, selectedModelId: "" };

        case TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_ID:
            return { ...state, selectedModelId: action.modelId };

        default:
            return state;
    }
};

export default TradeInAemModelSelectReducer;
